"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowButtonTextEditor_1 = require("../../../../../../shared/components/editors/CardRowButtonTextEditor");
var BrandLandingEditor = /** @class */ (function (_super) {
    __extends(BrandLandingEditor, _super);
    function BrandLandingEditor(props) {
        return _super.call(this, props) || this;
    }
    BrandLandingEditor.prototype.getPriorityAvail = function () {
        var _ret = [];
        for (var i = 1; i <= 10; i++) {
            _ret.push({
                key: i,
                value: "\u041D\u043E\u043C\u0435\u0440-" + i,
            });
        }
        return _ret;
    };
    BrandLandingEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    landing_identity: _item.landing_identity,
                    cms_image_url: _item.cms_image_url,
                    is_deprecated: _item.is_deprecated,
                    is_all_country: _item.is_all_country,
                    brand_id: _item.brand_id,
                    brand_title: _item.brand_title,
                    order_number_key: _item.order_number,
                    order_number_val: "\u041D\u043E\u043C\u0435\u0440-" + _item.order_number,
                    order_number_avail: this.getPriorityAvail(),
                    is_main_page: _item.is_main_page
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование лендинга"]);
                });
            }
        }
        else {
            this.setState({
                title: "",
                landing_identity: "",
                cms_image_url: "",
                is_deprecated: false,
                is_all_country: false,
                brand_id: 0,
                brand_title: "",
                order_number_key: 1,
                order_number_val: "\u041D\u043E\u043C\u0435\u0440-" + 1,
                order_number_avail: this.getPriorityAvail(),
                is_main_page: false
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание лендинга"]);
            });
        }
        this.doReSetRules();
    };
    BrandLandingEditor.prototype.doReSetRules = function () {
        this.setState({
            landing_identity_rules: { isError: false },
            cms_image_url_rules: { isError: false },
            title_rules: { isError: false },
            brand_rules: { isError: false },
            order_number_rules: { isError: false }
        });
    };
    BrandLandingEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        if ((!this.state.cms_image_url) || (this.state.cms_image_url.length === 0)) {
            this.setState({ cms_image_url_rules: { isError: true, errorMessage: "Поле [изображение лендинга] не выбрано!" } });
            return false;
        }
        if (!this.state.is_main_page) {
            if ((!this.state.landing_identity) || (this.state.landing_identity.length === 0)) {
                this.setState({ landing_identity_rules: { isError: true, errorMessage: "Поле [идентификатор лендинга] не заполнено!" } });
                return false;
            }
        }
        if ((this.state.brand_id <= 0) || (!this.state.brand_title) || (this.state.brand_title.length === 0)) {
            this.setState({ brand_rules: { isError: true, errorMessage: "Поле [бренд] не выбрано!" } });
            return false;
        }
        if ((this.state.order_number_key <= 0) || (this.state.order_number_val.length === 0)) {
            this.setState({ order_number_rules: { isError: true, errorMessage: "Поле [Порядковый номер] не выбрано!" } });
            return false;
        }
        return true;
    };
    BrandLandingEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                title: this.state.title,
                landing_identity: this.state.landing_identity,
                cms_image_url: this.state.cms_image_url,
                is_deprecated: this.state.is_deprecated,
                is_all_country: this.state.is_all_country,
                order_number: this.state.order_number_key,
                is_main_page: this.state.is_main_page
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Лендинг изменен!");
            });
        }
    };
    BrandLandingEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                brand_id: this.state.brand_id,
                title: this.state.title,
                landing_identity: this.state.landing_identity,
                cms_image_url: this.state.cms_image_url,
                is_deprecated: this.state.is_deprecated,
                is_all_country: this.state.is_all_country,
                order_number: this.state.order_number_key,
                is_main_page: this.state.is_main_page
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Лендинг добавлен!");
            });
        }
    };
    BrandLandingEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BrandLandingEditor.prototype.getFormTitle = function () {
        if (this.props.record == null) {
            return "Добавить лендинг";
        }
        else {
            return "Изменить лендинг";
        }
    };
    BrandLandingEditor.prototype.DoShowSelectImageDialog = function () {
        var _this = this;
        this.props.dialogSelectImage.SetDialogTitle("Выбор изображения").SetOnSelect(function (brandIdentity, dirName, fileName) {
            _this.setState({ cms_image_url: brandIdentity + "/" + dirName + "/" + fileName }, function () {
                _this.props.dialogSelectImage.Close();
            });
        }).Show();
    };
    BrandLandingEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 560 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бренд:", placeholder: "Выберите бренд лендинга" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false }
                    });
                }, items: this.props.brandsAvail, disabled: this.props.record != null, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Идентификатор:", placeholder: "Введите идентификатор лендинга" }, value: this.state.landing_identity, onValueChanged: function (newVal) {
                    _this.setState({
                        landing_identity: newVal,
                        landing_identity_rules: { isError: false }
                    });
                }, required: !this.state.is_main_page, rules: this.state.landing_identity_rules, disabled: this.state.is_main_page }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Порядковый номер:", placeholder: "Выберите порядковый номер" }, value: { key: this.state.order_number_key, value: this.state.order_number_val }, onValueChanged: function (newVal) {
                    _this.setState({
                        order_number_key: newVal.key,
                        order_number_val: newVal.value,
                        order_number_rules: { isError: false }
                    });
                }, items: this.state.order_number_avail, required: true, rules: this.state.order_number_rules }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: {
                    caption: "Изображение:",
                    placeholder: "Выберите изображение",
                    buttonHint: "Выберите изображение"
                }, readonly: true, onButtonClick: this.DoShowSelectImageDialog.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        cms_image_url: newVal,
                        cms_image_url_rules: { isError: false }
                    });
                }, value: this.state.cms_image_url, buttonIcon: "search", required: true, rules: this.state.cms_image_url_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Устарел", value: this.state.is_deprecated, onChecked: function (checked) {
                    _this.setState({
                        is_deprecated: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Все страны", value: this.state.is_all_country, onChecked: function (checked) {
                    _this.setState({
                        is_all_country: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Основная страница", value: this.state.is_main_page, onChecked: function (checked) {
                    _this.setState({
                        is_main_page: checked
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return BrandLandingEditor;
}(React.Component));
exports.default = BrandLandingEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_brands_landings_list/ui/component/BrandLandingEditor.tsx
// module id = 2417
// module chunks = 0